import React, { useEffect, useState } from "react";
import {
  ContactMeContainer,
  ContactMeSubHeading,
  ContactMeSubText,
  ContactMeSubscription,
  ContactMeRow,
  Form,
  FormInput,
  FormInputMessage,
  ContactMeLinkTitle,
  ContactMeLinksItems,
  ContactMeDataPersonal,
  ContactMeEmailIcon,
  ContactMeLocationIcon,
  ContactMePhoneIcon,
  ContactMeLink,
  ContactMeData,
  Button,
} from "./ContactMe.elements";
import Aos from "aos";
import "aos/dist/aos.css";

export default function ContactMe({ id, light }) {
  const [contactData, setcontactData] = useState(null);
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const onChange = (e) => {
    setcontactData({
      ...contactData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <ContactMeContainer id={id} className="seccion" light={light}>
      <ContactMeSubHeading light={light} data-aos="fade-up">
        CONTACTO
      </ContactMeSubHeading>
      <ContactMeRow
        data-aos="zoom-in-up"
        data-aos-offset="300"
        data-aos-easing="ease-in-sine"
      >
        <ContactMeData light={light}>
          <ContactMeDataPersonal>Datos personales: </ContactMeDataPersonal>
          <ContactMeLinksItems>
            <ContactMeLinkTitle light={light}>
              Región
              <ContactMeLocationIcon />
            </ContactMeLinkTitle>
            <ContactMeLink light={light}>Ciudad Real, España</ContactMeLink>
          </ContactMeLinksItems>
          <ContactMeLinksItems>
            <ContactMeLinkTitle light={light}>
              Teléfono
              <ContactMePhoneIcon />
            </ContactMeLinkTitle>
            <ContactMeLink light={light}>+34 634 729 535</ContactMeLink>
          </ContactMeLinksItems>
          <ContactMeLinksItems>
            <ContactMeLinkTitle light={light}>
              Email <ContactMeEmailIcon />
            </ContactMeLinkTitle>
            <ContactMeLink light={light}>
              alonsodiazsobrino@hotmail.es
            </ContactMeLink>
          </ContactMeLinksItems>
        </ContactMeData>
        <ContactMeSubscription light={light}>
          <ContactMeSubText>
            Aquí puedes rellenar el formulario para contactarme:
          </ContactMeSubText>

          <Form
            action="https://formsubmit.co/alonsodiazsobrino@hotmail.es"
            method="POST"
            target="_blank"
          >
            <FormInput
              light={light}
              name="name"
              type="name"
              placeholder="Nombre..."
              onChange={onChange}
            ></FormInput>
            <FormInput
              light={light}
              name="email"
              type="email"
              placeholder="Email..."
              onChange={onChange}
            ></FormInput>
            <FormInput
              light={light}
              name="subject"
              type="subject"
              placeholder="Asunto..."
              onChange={onChange}
            ></FormInput>
            <FormInputMessage
              light={light}
              name="message"
              type="message"
              placeholder="Mensaje..."
              onChange={onChange}
            ></FormInputMessage>
            <Button light={light} type="submit">
              ENVIAR
            </Button>
          </Form>
        </ContactMeSubscription>
      </ContactMeRow>
    </ContactMeContainer>
  );
}
